export default function isHtmlElement(el) {
	return el instanceof HTMLElement
}
